import { useRouter } from "next/router";
import type { ComponentProps } from "react";
import { useEffect, useState } from "react";
import {
  addSearch,
  resetSearchWord,
  setToggleSearch,
} from "src/reducks/SearchStore";
import { fumufumuApi } from "src/service/FumuFumuApi";
import { usersApi } from "src/service/UsersApi";
import { store } from "src/store";

const FUMUFUMU_PAGE_TITLE_ITEM = [
  { label: "にコメント", path: "comment" },
  { label: "のスレッド", path: "detail" },
  { label: "新規投稿", path: "post" },
  { label: "新規投稿", path: "edit" },
];

export const useFumufumuPageTitle = () => {
  const router = useRouter();
  const [pageTitle, setPageTitle] = useState("");
  const [pagePath, setPagePath] = useState("");
  const [checkedPostPage, setCheckedPostPage] = useState(false);

  const pathArray = router.asPath.split("/") || [];

  const headPageItem = FUMUFUMU_PAGE_TITLE_ITEM.filter((item) => {
    return pathArray[2] && item.path === pathArray[2];
  }).flat();

  useEffect(() => {
    if (headPageItem.length === 0) {
      setPageTitle("フムフム");
      setPagePath("fumufumu");
      setCheckedPostPage(false);
    } else {
      // pathをセット
      setPagePath(headPageItem[0].path);

      // 投稿ページなのかをチェック
      if (
        pagePath === "post" ||
        pagePath === "comment" ||
        pagePath === "edit"
      ) {
        setCheckedPostPage(true);
      } else {
        setCheckedPostPage(false);
      }

      // 各ページのタイトルを設定
      if (pagePath === "post" || pagePath === "edit") {
        setPageTitle(headPageItem[0].label);
        return;
      }

      if (pagePath === "comment" || pagePath === "detail") {
        const fumufumu = fumufumuApi.endpoints.getFumufumu.select(
          router.query.id as string,
        )(store.getState());
        const user = usersApi.endpoints.getUser.select(
          fumufumu.data?.userId as string,
        )(store.getState());
        setPageTitle(`${user.data?.nickname} ${headPageItem[0].label}`);
        return;
      }
    }
  }, [headPageItem, pagePath, router.query.id]);

  return { checkedPostPage, pagePath, pageTitle };
};

// 検索フォームの開閉
export const toggleSearch: () => void = () => {
  store.dispatch(setToggleSearch());
  store.dispatch(resetSearchWord());
};

// 日本語入力の検索インプット
export const handleCompositionEnd: ComponentProps<"input">["onCompositionEnd"] =
  (e) => {
    store.dispatch(addSearch(e.currentTarget.value));
    // 変換結果をサーバーに送信するリクエストを行う
  };
// 日本語入力かを判定
export const isJapaneseInput = (text: string) => {
  const regex =
    /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}\p{Script=Common}ー]/u;
  return regex.test(text);
};
// アルファベット入力の検索インプット
export const handleChange: ComponentProps<"input">["onChange"] = (e) => {
  const inputText = e.currentTarget.value;
  if (!isJapaneseInput(inputText)) {
    store.dispatch(addSearch(e.currentTarget.value));
    // リクエストを送信する
  }
};
